export default __webpack_public_path__ + "static/media/spiderman-ps4-new_1570393512.26ed6a65.jpg";